import React, { useState } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { Checkbox } from './../../../../../Components/Form/Checkbox'
import injectStyles from 'react-jss'
import { updateAmbassadorById } from 'Reducers/Ambassador/actions'
import { connect } from 'react-redux'
import { styles } from './style'
import { createUserProfileLog } from '../../Ambasador/gql'
import { USER_PROFILE_LOGS_TYPE } from '../../../../../constants'

const BankDetailsSectionView = ({
  ambassadorId,
  paymentDetails,
  classes,
  updateAmbassadorById,
  withholdPay,
  logsParams,
}) => {
  const [withholdPayTrack, setWithholdPayTrack] = useState(withholdPay)

  const toggleWithholdPay = async () => {
    setWithholdPayTrack(!withholdPayTrack)
    updateAmbassadorById(ambassadorId, { withhold_pay: !withholdPay })
    await createUserProfileLog(
      logsParams(
        !withholdPayTrack
          ? USER_PROFILE_LOGS_TYPE.WITHHOLD_PAY_TRUE
          : USER_PROFILE_LOGS_TYPE.WITHHOLD_PAY_FALSE,
      ),
    )
  }

  return (
    <Grid fluid>
      <Row>
        <Col xs={12}>
          <SectionTitle>Bank Details</SectionTitle>
        </Col>
        <div className={classes.withholdContainer}>
          <label className={classes.withoutLabel}>Withhold pay</label>
          <Checkbox
            className={classes.withoutCheckbox}
            input={{
              onClick: toggleWithholdPay,
              checked: withholdPay,
            }}
          />
        </div>
      </Row>
      {paymentDetails && (
        <Row>
          <Col xs={3}>
            <p className="col-title" cypress_id={'bankAccountNameColumn'}>
              Bank Name
            </p>
            <p>{paymentDetails.accountName || '-'}</p>
          </Col>
          <Col xs={3}>
            <p className="col-title" cypress_id={'bankBranchNumberColumn'}>
              BSB
            </p>
            <p>{paymentDetails.branchNumber || '-'}</p>
          </Col>
          <Col xs={3}>
            <p className="col-title" cypress_id={'bankAccountNumberColumn'}>
              Account Number
            </p>
            <p>{paymentDetails.accountNumber || '-'}</p>
          </Col>
        </Row>
      )}
    </Grid>
  )
}

const StyledBankDetailsSection = injectStyles(styles)(BankDetailsSectionView)

const ConnectedBankDetailsSection = connect(
  null,
  { updateAmbassadorById },
)(StyledBankDetailsSection)

export default ConnectedBankDetailsSection
